export const SET_THSROPTSMOPEN = 'SET_THSROPTSMOPEN';
export const SET_THSRINITDATA = 'SET_THSRINITDATA';
export const SET_THSRISINITFAIL = 'SET_THSRISINITFAIL';
export const SET_THSRDETAILDATA = 'SET_THSRDETAILDATA';
export const SET_TCURRENTSTEP = 'SET_TCURRENTSTEP';
export const SET_THSRSTATIONS = 'SET_THSRSTATIONS';
export const SET_THSRDETAILLOADING = 'SET_THSRDETAILLOADING';
export const SET_THSRSEARCHOPTION = 'SET_THSRSEARCHOPTION';
export const SET_THSROPENEDPANEL = 'SET_THSROPENEDPANEL';
export const SET_THSRInfo = 'SET_THSRInfo';
export const SET_THSRDEPARTTRAIN = 'SET_THSRDEPARTTRAIN';
export const SET_THSRRETURNTRAIN = 'SET_THSRRETURNTRAIN';
export const SER_THSROTHERTIMELOADING = 'SER_THSROTHERTIMELOADING';
export const SET_THSRHIGHESTDISCOUNTS = 'SET_THSRHIGHESTDISCOUNTS';
export const SET_THSRTEMPTRAINITEMS='SET_THSRTEMPTRAINITEMS';